export function InteractionPrompt({ target, message, touch }) {
  return (
    <div className="interaction-prompt" role="status">
      {target ? (
        <>
          <strong>{target.verb}</strong>
          <span>
            {target.requires ? `Use ${target.requires} · ` : ''}
            {touch ? 'Tap Interact' : 'Press E'}
          </span>
        </>
      ) : (
        message
      )}
    </div>
  );
}
